import MonthlyTrainingPlanSummary from "../../monthly-training-plan-summary";
import CreateMTPSPage from "../../monthly-training-plan-summary/pages/MTPS-create";
import MTPSDetailPage from "../../monthly-training-plan-summary/pages/MTPS-detail";

export const monthlyTrainingPlanSummaryRoutes = {
  mtpsPage: {
    isAdmin: false,
    title: "6. Bảng tổng hợp kế hoạch đào tạo tháng",
    path: "/procedure/monthly-training-plan-summary",
    parentId: "procedure",
    component: MonthlyTrainingPlanSummary,
  },
  createMTPSPage: {
    title: "",
    path: "/procedure/monthly-training-plan-summary/create",
    parentId: "procedure",
    component: CreateMTPSPage,
  },
  mtpsDetailPage: {
    title: "",
    path: "/procedure/monthly-training-plan-summary/:id",
    parentId: "procedure",
    component: MTPSDetailPage,
  },
};
